import { TypeProfileModel } from '@app/src/views/StepPayment/formPayment/models/TypeProfileModel';
import { TypeProfileDTO, TypeProfilePostDTO } from '@app/src/views/StepPayment/formPayment/dtos';

export const hydrateData = (data: TypeProfileDTO) => ({
  id: data.id,
  name: data.first_name,
  fatherLastName: data.father_last_name,
  motherLastName: data.mother_last_name,
  businessName: data.business_name,
  documentType: data.document_type,
  documentNumber: data.document_number,
  phone: data.phone_number,
  email: data.email,
  address: data.address,
  districtId: data.district_id,
  departmentId: data.department_id,
  adecsysCustomer: data.adecsys_customer,
  location: data.location
} as TypeProfileModel)

export const hydrateDataPost = (data) => ({
  business_name: data.rznSocial,
  first_name: data.businessName,
  father_last_name: data.businessFatherLastName,
  mother_last_name: data.businessMotherLastName,
  document_type: 'RUC',
  document_number: data.ruc,
  phone_number: data.businessPhone,
  email: data.businessEmail,
  adecsys_customer: '',
  department_id: data.departmentId,
  district_id: data.districtId,
  address: data.businessAddress,
  location: data.location
} as TypeProfilePostDTO)

export const hydrateDataPut = (data) => ({
  first_name: data.businessName,
  father_last_name: data.businessFatherLastName,
  mother_last_name: data.businessMotherLastName,
  phone_number: data.businessPhone,
  email: data.businessEmail,
} as TypeProfilePostDTO)